/* cv-cart.js  (bag, Release 1 wave 2). Deferred, no libraries, no network call unless a bag section needs a refresh.
 *
 * 1. After-add sheet. Dawn's cart-notification.js still opens and closes it (the class "active" on #cart-notification).
 *    This file only adds what the spec asks for around that: a scrim, the Back button closing the sheet (a history
 *    entry is pushed on open and popped on close), focus on open when reduced motion removes the transitionend Dawn
 *    waits for, and the custom pixel event cart_sheet_open.
 * 2. Cart page. Dawn re-renders the items section and the footer section after a quantity change, and the meter lives
 *    inside the items section, so the meter is already fresh. Two things Dawn does not re-render are handled here:
 *    the one-more-tee upsell (its own section, re-fetched on every cart update) and a persistent live region that
 *    announces the new meter sentence.
 * 3. cart_checkout_click: a passive capture listener on the Check out buttons. It never calls preventDefault or
 *    stopPropagation, so Razorpay Magic's own handlers run exactly as before.
 *
 * Only custom pixel events are fired here (trackCustom). No standard event, no second AddToCart path.
 */
(function () {
  'use strict';
  if (window.__cvCartLoaded) return;
  window.__cvCartLoaded = true;

  function track(name, params) {
    try {
      if (typeof window.cvTrack === 'function') {
        window.cvTrack(name, params || {});
      } else if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', name, params || {});
      }
    } catch (e) {}
  }

  /* ------------------------------------------------------------------ 1. after-add sheet */
  function initSheet() {
    var host = document.querySelector('cart-notification');
    var sheet = document.getElementById('cart-notification');
    if (!host || !sheet) return;

    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var wasOpen = sheet.classList.contains('active');
    var pushed = false;
    var skipPop = false;

    function isOpen() {
      return sheet.classList.contains('active');
    }

    function onOpen() {
      host.classList.add('cv-open');
      document.documentElement.classList.add('cv-lock'); /* page scroll locked while the sheet is open (spec 3.9) */
      try {
        history.pushState({ cvAfterAdd: 1 }, '', location.href);
        pushed = true;
      } catch (e) {
        pushed = false;
      }
      track('cart_sheet_open');
      /* Dawn moves focus into the sheet on transitionend. With reduced motion the transition has zero length and that
         event never fires, so do it here. */
      if (reduce.matches) {
        try {
          sheet.focus({ preventScroll: true });
          if (typeof trapFocus === 'function') trapFocus(sheet);
        } catch (e) {}
      }
    }

    function onClose() {
      host.classList.remove('cv-open');
      document.documentElement.classList.remove('cv-lock');
      if (pushed) {
        pushed = false;
        if (history.state && history.state.cvAfterAdd) {
          skipPop = true;
          try {
            history.back();
          } catch (e) {
            skipPop = false;
          }
        }
      }
    }

    new MutationObserver(function () {
      var open = isOpen();
      if (open && !wasOpen) {
        wasOpen = true;
        onOpen();
      } else if (!open && wasOpen) {
        wasOpen = false;
        onClose();
      }
    }).observe(sheet, { attributes: true, attributeFilter: ['class'] });

    /* the browser Back button closes the sheet */
    window.addEventListener('popstate', function () {
      if (skipPop) {
        skipPop = false;
        return;
      }
      if (pushed && isOpen()) {
        pushed = false;
        if (typeof host.close === 'function') host.close();
      }
    });

    /* a tap on the scrim (the host element's own ::before) closes it; Dawn's body handler ignores it */
    host.addEventListener('click', function (e) {
      if (e.target === host && isOpen() && typeof host.close === 'function') host.close();
    });

    /* View bag: drop the history entry first so Back from the bag does not land on a dead duplicate of this page */
    sheet.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || !pushed || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (a.target && a.target !== '_self') return;
      e.preventDefault();
      var href = a.href;
      var done = false;
      function go() {
        if (done) return;
        done = true;
        window.removeEventListener('popstate', go);
        location.assign(href);
      }
      pushed = false;
      window.addEventListener('popstate', go);
      setTimeout(go, 400);
      try {
        history.back();
      } catch (err) {
        go();
      }
    });
  }

  /* ------------------------------------------------------------------ 2. cart page */
  var upsellSeq = 0;

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function refreshUpsell() {
    var root = document.querySelector('[data-cv-upsell]');
    if (!root) return Promise.resolve();
    var id = root.getAttribute('data-section-id');
    if (!id) return Promise.resolve();
    var seq = ++upsellSeq;
    return fetch(cartUrl() + '?section_id=' + encodeURIComponent(id))
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        if (seq !== upsellSeq) return; /* a newer update already won */
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cv-upsell]');
        var current = document.querySelector('[data-cv-upsell]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* the sentence(s) the meter shows now, announced through one persistent live region (the meter itself is replaced
     wholesale by Dawn, which screen readers do not announce) */
  function announceMeter(silent) {
    var live = document.getElementById('cv-meter-live');
    if (!live) return;
    var lines = document.querySelectorAll('cart-items [data-cv-meter] .cv-meter__line');
    var text = Array.prototype.map
      .call(lines, function (n) {
        return n.textContent.replace(/\s+/g, ' ').trim();
      })
      .join(' ');
    if (live.textContent === text) return;
    if (silent) {
      live.textContent = text;
    } else {
      live.textContent = '';
      setTimeout(function () {
        live.textContent = text;
      }, 50);
    }
  }

  function onCartUpdate() {
    refreshUpsell();
    announceMeter(false);
  }

  function initCartPage() {
    if (!document.querySelector('cart-items')) return;
    announceMeter(true);
    /* constants.js declares PUB_SUB_EVENTS with const, so it is a global binding but not a window property */
    var evt = typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate ? PUB_SUB_EVENTS.cartUpdate : 'cart-update';
    if (typeof subscribe === 'function') subscribe(evt, onCartUpdate);
  }

  /* ------------------------------------------------------------------ 3. checkout click (observe only) */
  function initCheckoutTrack() {
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var b = t.closest('#cart-notification-form button[name="checkout"], #checkout.cart__checkout-button');
        if (b) track('cart_checkout_click', { where: b.id === 'checkout' ? 'bag' : 'sheet' });
        /* the meter's own links: "Pick tee n of 3" (upsell) and "See tees" (empty meter). Observe only, like the rest. */
        var m = t.closest('.cv-upsell__btn, .cv-meter__link');
        if (m) track('meter_slot_tap', { where: m.classList.contains('cv-upsell__btn') ? 'pick_tee' : 'see_tees' });
      },
      true
    );
  }

  function init() {
    initSheet();
    initCartPage();
    initCheckoutTrack();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* for other builders (quick add, the PDP add) that change the bag without Dawn's cartUpdate event */
  window.cvCart = { refreshUpsell: refreshUpsell, announceMeter: announceMeter };
})();
